import { useFormContext } from 'react-hook-form';
import { FormInputText } from '../../../../../base-forms';
import { Box, Icon, useTheme } from '../../../../../base-components';
import {
    ITableForm,
    TableFormValues,
} from '../../../../../../common/interfaces/table.interface';
import useDebouncedSearch from './useDebouncedSearch';
import { useTranslation } from 'react-i18next';

const Search = () => {
    const { control, getValues } = useFormContext<ITableForm>();
    const theme = useTheme();
    const { t } = useTranslation();

    useDebouncedSearch(getValues, control);

    return (
        <FormInputText
            name={TableFormValues.search}
            control={control}
            placeholder={t('tablesBase.search')}
            size={'small'}
            removeBottomPadding
            InputProps={{
                startAdornment: (
                    <Box sx={{ paddingInlineStart: theme.spacing(2) }}>
                        <Icon
                            name={'SearchIcon'}
                            color={theme.palette.grey[500]}
                        />
                    </Box>
                ),
            }}
        />
    );
};

export default Search;
